import { api } from 'app/app.api';

import {
  DeleteUserStorageApiArg,
  DeleteUserStorageApiResponse,
  ReadUserStorageApiArg,
  ReadUserStorageApiResponse,
  SetUserStorageApiArg,
  SetUserStorageApiResponse,
} from './types/userStorageApi.types';

export const userStorageApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readUserStorage: builder.query<
      ReadUserStorageApiResponse,
      ReadUserStorageApiArg
    >({
      query: ({ keys = [] }) => ({
        version: 4,
        path: 'user-storage',
        params: { keys },
      }),
    }),
    setUserStorage: builder.mutation<
      SetUserStorageApiResponse,
      SetUserStorageApiArg
    >({
      query: (body) => ({
        version: 4,
        path: 'user-storage',
        method: 'PATCH',
        body,
      }),
      async onQueryStarted(patch, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          userStorageApi.util.updateQueryData(
            'readUserStorage',
            {},
            (draft) => {
              Object.entries(patch).forEach(([key, value]) => {
                if (value === null) {
                  delete draft[key];
                } else {
                  draft[key] = value;
                }
              });
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    removeUserStorageByKey: builder.mutation<
      DeleteUserStorageApiResponse,
      DeleteUserStorageApiArg
    >({
      query: ({ key }) => ({
        version: 4,
        path: `user-storage/${key}`,
        method: 'DELETE',
      }),
      async onQueryStarted({ key }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          userStorageApi.util.updateQueryData(
            'readUserStorage',
            {},
            (draft) => {
              delete draft[key];
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});
